import React, { useState } from 'react';
import { motion } from "framer-motion";
import { BarChart, Bar, XAxis, YAxis, ResponsiveContainer } from 'recharts';
import { Info, X, Search } from 'lucide-react';
import { Link } from 'react-router-dom';
import aidaptiv_background from '../../assets/images/background.jpg';
import aidaptiv_image from '../../assets/images/aiDAPTIV+series1.png';
import FeaturesSection from '../../Components/Features/Features';
const trainingData = [
  { name: '7B', aiDaptiv: 0.5, gpuOnly: 0.4 },
  { name: '13B', aiDaptiv: 0.8, gpuOnly: 0 },
  { name: '70B', aiDaptiv: 4.3, gpuOnly: 0 }
];

const modelInfo = [
  {
    title: "7B Model",
    trainingSet: "140 GB",
    hbmUsage: "192 GB (73%)",
    gpuCount: "4 / 4"
  },
  {
    title: "13B Model",
    trainingSet: "260 GB",
    hbmUsage: "192 GB (126%)",
    gpuCount: "4 / 6"
  },
  {
    title: "70B Model",
    trainingSet: "1400 GB",
    hbmUsage: "192 GB (729%)",
    gpuCount: "4 / 30"
  }
];

const models = [
    { id: 1, name: "Llama3.1_405b", type: "Text Generation" },
    { id: 2, name: "Falcon", type: "Text Generation" },
    { id: 3, name: "Bert", type: "Fill Mask" },
    { id: 4, name: "ResNet-50", type: "Image Classification" },
    { id: 5, name: "Qwen1.5-110B-Chat", type: "Text Generation" },
    { id: 6, name: "Llama3.1_70b", type: "Text Generation" },
    { id: 7, name: "Nemtron-70B", type: "Text Generation" },
    { id: 8, name: "Whisper v2", type: "Speech Recognition" },
    { id: 9, name: "clip-vit-large-patch14", type: "Zero-Shot Image Classification" },
    { id: 10, name: "paligemma2-3b-pt-224", type: "Image-Text-to-Text" },
    { id: 11, name: "Gemma2_9b", type: "Text Generation" },
    { id: 12, name: "Gemma2_27b", type: "Text Generation" },
    { id: 13, name: "Whisper v3", type: "Speech Recognition" },
    { id: 14, name: "Llama3.1_8b", type: "Text Generation" },
    { id: 15, name: "Llama II-7B", type: "Text Generation" },
    { id: 16, name: "Llama II-13B", type: "Text Generation" },
    { id: 17, name: "Llama II-70B", type: "Text Generation" },
    { id: 18, name: "Llama III-8B", type: "Text Generation" },
    { id: 19, name: "Llama III-70B", type: "Text Generation" },
    { id: 20, name: "Llama-3-Taiwan-70B-Instruct", type: "Text Generation" },
    { id: 21, name: "LlamaGuard-7b", type: "Text Generation" },
    { id: 22, name: "Meta-Llama-3-8B", type: "Text Generation" },
    { id: 23, name: "Meta-Llama-3-70B", type: "Text Generation" },
    { id: 24, name: "Phind-CodeLlama-34B-v1", type: "Text Generation" },
    { id: 25, name: "Code Llama-7B", type: "Text Generation" },
    { id: 26, name: "Code Llama-13B", type: "Text Generation" },
    { id: 27, name: "Code Llama-70B", type: "Text Generation" },
    { id: 28, name: "Mistral", type: "Text Generation" },
    { id: 29, name: "Mixtral 8x7B", type: "Text Generation" },
    { id: 30, name: "Mixtral 8x22B", type: "Text Generation" },
    { id: 31, name: "TAIDE", type: "Text Generation" },
    { id: 32, name: "Breeze", type: "Text Generation" },
    { id: 33, name: "Vicuna", type: "Text Generation" },
    { id: 34, name: "Qwen2-7B", type: "Text Generation" },
    { id: 35, name: "Qwen2-72B", type: "Text Generation" },
    { id: 36, name: "Qwen2-72B-Instruct", type: "Text Generation" },
    { id: 37, name: "Qwen1.5-0.5B-Chat", type: "Text Generation" },
    { id: 38, name: "Qwen1.5-1.8B-Chat", type: "Text Generation" },
    { id: 39, name: "Qwen1.5-4B-Chat", type: "Text Generation" },
    { id: 40, name: "Qwen1.5-7B-Chat", type: "Text Generation" },
    { id: 41, name: "Qwen1.5-14B-Chat", type: "Text Generation" },
    { id: 42, name: "Qwen1.5-72B-Chat", type: "Text Generation" },
    { id: 43, name: "chatglm-6b", type: "Text Generation" },
    { id: 44, name: "chatglm3-6b", type: "Text Generation" },
    { id: 45, name: "deepseek-llm-7b-chat", type: "Text Generation" },
    { id: 46, name: "deepseek-llm-67b-chat", type: "Text Generation" },
    { id: 47, name: "deepseek-moe-16b-chat", type: "Text Generation" },
    { id: 48, name: "Baichuan-7B", type: "Text Generation" },
    { id: 49, name: "Baichuan2-7B-Chat", type: "Text Generation" },
    { id: 50, name: "Yi-1.5-6B", type: "Text Generation" },
    { id: 51, name: "Yi-1.5-9B-Chat", type: "Text Generation" },
    { id: 52, name: "Yi-1.5-34B-Chat", type: "Text Generation" },
    { id: 53, name: "Yuan2-M32-hf", type: "Text Generation" },
    { id: 54, name: "Facebook/opt-125m", type: "Text Generation" }
  ];
  
  const gpus = [
    { id: 1, name: "NVIDIA A100", memory: "80 GB | HBM2e" },
    { id: 2, name: "NVIDIA RTX A6000", memory: "48 GB | GDDR6" },
    { id: 3, name: "NVIDIA RTX A5000", memory: "24 GB | GDDR6" },
    { id: 4, name: "NVIDIA RTX A4000", memory: "16 GB | GDDR6" },
    { id: 5, name: "NVIDIA L40", memory: "48 GB | GDDR6" },
    { id: 6, name: "NVIDIA L40S", memory: "48 GB | GDDR6" },
    { id: 7, name: "NVIDIA RTX 2000 Ada Generation", memory: "16 GB | GDDR6" },
    { id: 8, name: "NVIDIA RTX 4000 ADA Generation", memory: "20 GB | GDDR6" },
    { id: 9, name: "NVIDIA RTX 4000SSF ADA Generation", memory: "20 GB | GDDR6" },
    { id: 10, name: "NVIDIA RTX 5000 ADA Generation", memory: "32 GB | GDDR6" },
    { id: 11, name: "NVIDIA GeForce RTX 4090 D", memory: "24 GB | GDDR6X" },
    { id: 12, name: "NVIDIA GeForce RTX 4090", memory: "24 GB | GDDR6X" },
    { id: 13, name: "AMD Radeon RX 7900 XTX", memory: "24 GB | GDDR6" },
    { id: 14, name: "AMD Radeon PRO W7900", memory: "48 GB | GDDR6" },
    { id: 15, name: "NVIDIA H200", memory: "141 GB | HBM3e" },
    { id: 16, name: "AMD MI100", memory: "32 GB | HBM2" },
    { id: 17, name: "AMD MI210", memory: "64 GB | HBM2e" },
    { id: 18, name: "AMD MI250", memory: "128 GB | HBM2e" },
    { id: 19, name: "AMD MI250X", memory: "128 GB | HBM2e" },
    { id: 20, name: "AMD MI300A", memory: "128 GB | HBM3" },
    { id: 21, name: "AMD MI300X", memory: "192 GB | HBM3" },
  ];
  
  const benefits = [
    "Transparent drop-in",
    "No need to change your AI Application",
    "Reuse existing HW or add nodes"
  ];
  
  const middleware = [
    "Slice model, assign to each GPU",
    "Hold pending slices on aiDAPTIVCache",
    "Swap pending slices w/ finished slices on GPU"
  ];
  
  const integrators = [
    "Access to ai100E SSD",
    "Middleware library license",
    "Full MiPhi support in system bring up"
  ];
  
  const servicesData = {
    "aiDAPTIV+": {
      title: "Unlock Large Model Training",
      description: `Until aiDAPTIV+, small and medium-sized businesses have been limited to small, imprecise model trainings with the ability to scale beyond Llama-2 7b. MiPhi's aiDAPTIV+ solution enables significantly larger training models, giving you the opportunity to run workloads previously reserved for data-centers.`,
      type: "special"
    },
    "aiDAPTIV+Link": {
      title: "aiDAPTIV+Link",
      description: `Our software developers create bespoke e-commerce platforms designed specifically for your business.`,
      sections: {
        benefits,
        middleware,
        integrators
      }
    },
  "aiDAPTIV+Cache": {
    title: "aiDAPTIV+Cache",
    description: "Enhance your GPU memory capacity with our advanced caching solution that enables seamless integration and high endurance performance.",
    sections: {
      "SEAMLESS INTEGRATION": [
        "Optimized middleware to extend GPU memory capacity",
        "2x 2TB aiDAPTIV+Cache to support 70B model",
        "Low latency"
      ],
      "HIGH ENDURANCE": [
        "Industry-leading 100 DWPD with 5-year warranty",
        "SLC NAND with advanced NAND correction algorithm"
      ]
    }
  },
  "Qualified Models": {
    title: "aiDAPTIV+ Qualified Models",
    description: `Transform your data into actionable insights with our custom dashboard solutions. We create 
    intuitive and interactive visualizations that help you monitor KPIs, track performance, and make data-driven 
    decisions.`,
    imagePath: "/api/placeholder/800/600"
  },
  "Qualified GPUs": {
    title: "aiDAPTIV+ Qualified GPUs",
    description: `We create comprehensive design systems that ensure consistency across your digital products. 
    Our approach combines aesthetic excellence with practical functionality, delivering a cohesive brand experience 
    across all platforms.`,
    imagePath: "/api/placeholder/800/600"
  }
}
const Modal = ({ isOpen, onClose, children }) => {
    if (!isOpen) return null;
  
    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
        <div className="bg-gray-900 rounded-xl w-full max-w-2xl max-h-[80vh] overflow-hidden relative">
          <button
            onClick={onClose}
            className="absolute right-4 top-4 text-gray-400 hover:text-white"
          >
            <X className="w-6 h-6" />
          </button>
          {children}
        </div>
      </div>
    );
  };
  
  const SearchDialog = ({ isOpen, onClose, items, type }) => {
    const [searchTerm, setSearchTerm] = useState('');
    
    const filteredItems = items.filter(item => 
      item.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      (item.type && item.type.toLowerCase().includes(searchTerm.toLowerCase()))
    );
  
    return (
      <div className={`fixed inset-0 bg-black bg-opacity-50 z-50 ${isOpen ? 'flex' : 'hidden'} items-center justify-center p-4`}>
        <div className="bg-gray-900 rounded-xl w-full max-w-5xl max-h-[80vh] overflow-hidden relative">
          <button
            onClick={onClose}
            className="absolute right-4 top-4 text-gray-400 hover:text-white"
          >
            <X className="w-6 h-6" />
          </button>
          <div className="p-6">
            <h2 className="text-xl font-bold mb-4">
              {type === 'models' ? 'Qualified Models' : 'Qualified GPUs'}
            </h2>
            <div className="relative mb-4">
              <Search className="absolute left-3 top-3 h-4 w-4 text-gray-500" />
              <input
                type="text"
                placeholder={`Search ${type}...`}
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="w-full pl-10 pr-4 py-2 bg-gray-800 border border-gray-700 rounded-lg text-white focus:outline-none focus:border-blue-500"
              />
            </div>
            <div className="overflow-y-auto max-h-[50vh]">
              <div className="grid grid-cols-2 gap-4">
                {filteredItems.map((item) => (
                  <div
                    key={item.id}
                    className="p-4 rounded-lg bg-gray-800 hover:bg-gray-700 transition-colors"
                  >
                    <h3 className="font-medium text-white">{item.name}</h3>
                    <p className="text-sm text-gray-400">
                      {type === 'models' ? item.type : item.memory}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };
  export default function Services() {
    const [activeService, setActiveService] = useState("aiDAPTIV+");
    const [showModelsDialog, setShowModelsDialog] = useState(false);
    const [showGPUsDialog, setShowGPUsDialog] = useState(false);
  
    const renderServiceContent = () => {
        if (activeService === "aiDAPTIV+Link") {
            return (
              <div className="grid md:grid-cols-2 gap-12">
                <motion.div
                  initial={{ x: -50, opacity: 0 }}
                  animate={{ x: 0, opacity: 1 }}
                  transition={{ delay: 0.2 }}
                  className="space-y-8"
                >
                  {Object.entries(servicesData["aiDAPTIV+Link"].sections).map(([title, items], index) => (
                    <motion.div
                      key={title}
                      initial={{ y: 20, opacity: 0 }}
                      animate={{ y: 0, opacity: 1 }}
                      transition={{ delay: index * 0.1 }}
                      className="backdrop-blur-xl bg-white/5 rounded-xl p-6 border border-white/10"
                    >
                      <h3 className="text-xl font-bold mb-4 uppercase">{title}</h3>
                      <ul className="space-y-3">
                        {items.map((item, i) => (
                          <li key={i} className="flex items-center gap-2">
                            <div className="w-2 h-2 bg-emerald-500 rounded-full" />
                            <span className="text-gray-300">{item}</span>
                          </li>
                        ))}
                      </ul>
                    </motion.div>
                  ))}
                </motion.div>
                <motion.div
                  initial={{ x: 50, opacity: 0 }}
                  animate={{ x: 0, opacity: 1 }}
                  transition={{ delay: 0.4 }}
                  className="relative h-full min-h-[400px] rounded-xl overflow-hidden"
                >
                  <div className="absolute inset-0 w-full h-full object-cover rounded-xl">
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 800 600">
   
    <text x="400" y="50" text-anchor="middle" font-family="Arial" font-size="40" font-weight="bold">
      <tspan fill="#2D3748">ai</tspan><tspan fill="#047857">DAPTIV+</tspan><tspan fill="#10B981">Link</tspan>
    </text>

   
    <text x="400" y="90" text-anchor="middle" font-family="Arial" font-size="24" fill="#4B5563">
      Drop-in solution for all existing AI applications
    </text>

  
    <rect x="150" y="150" width="500" height="70" fill="#F3F4F6" rx="5"/>
    <text x="400" y="190" text-anchor="middle" font-family="Arial" font-size="24" fill="#374151">
      AI Application
    </text>


    <rect x="150" y="240" width="500" height="90" fill="#F3F4F6" rx="5"/>
    <text x="400" y="280" text-anchor="middle" font-family="Arial" font-size="24" fill="#374151">
      PyTorch
    </text>
    <text x="400" y="310" text-anchor="middle" font-family="Arial" font-size="20" fill="#6B7280">
      AI Framework
    </text>

   
    <rect x="150" y="350" width="500" height="90" fill="#10B981" rx="5"/>
    <text x="400" y="390" text-anchor="middle" font-family="Arial" font-size="24" fill="white" font-weight="bold">
      aiDAPTIV+Link
    </text>
    <text x="400" y="420" text-anchor="middle" font-family="Arial" font-size="20" fill="white">
      Middleware Library
    </text>


    <rect x="150" y="460" width="240" height="90" fill="#F3F4F6" rx="5"/>
    <text x="270" y="500" text-anchor="middle" font-family="Arial" font-size="24" fill="#374151">
      GPU
    </text>
    <text x="270" y="530" text-anchor="middle" font-family="Arial" font-size="20" fill="#6B7280">
      Cost Efficient
    </text>

    <rect x="410" y="460" width="240" height="90" fill="#F3F4F6" rx="5"/>
    <text x="530" y="500" text-anchor="middle" font-family="Arial" font-size="24" fill="#047857">
      aiDAPTIV+Cache
    </text>
    <text x="530" y="530" text-anchor="middle" font-family="Arial" font-size="20" fill="#6B7280">
      100 DWPD
    </text>
  </svg>
</div>

                  <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />
                </motion.div>
              </div>
            );
          }

          if (activeService === "aiDAPTIV+Cache") {
            return (
              <div className="flex flex-col md:flex-row items-center justify-center gap-12">
  <motion.div
    initial={{ x: -50, opacity: 0 }}
    animate={{ x: 0, opacity: 1 }}
    transition={{ delay: 0.2 }}
    className="space-y-8"
  >
    {Object.entries(servicesData["aiDAPTIV+Cache"].sections).map(([title, items], index) => (
      <motion.div
        key={title}
        initial={{ y: 20, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ delay: index * 0.1 }}
        className="backdrop-blur-xl bg-white/5 rounded-xl p-6 border border-white/10"
      >
        <h3 className="text-xl font-bold mb-4 uppercase">{title}</h3>
        <ul className="space-y-3">
          {items.map((item, i) => (
            <li key={i} className="flex items-center gap-2">
              <div className="w-2 h-2 bg-emerald-500 rounded-full" />
              <span className="text-gray-300">{item}</span>
            </li>
          ))}
        </ul>
      </motion.div>
    ))}
  </motion.div>

  <motion.div
    initial={{ x: 50, opacity: 0 }}
    animate={{ x: 0, opacity: 1 }}
    transition={{ delay: 0.4 }}
    className="relative flex-shrink-0 rounded-xl overflow-hidden"
  >
    <img
      src={aidaptiv_image}
      alt="aiDAPTIVCache"
      className="w-full max-w-sm md:max-w-lg lg:max-w-xl object-contain"
    />
  </motion.div>
</div>

            );
          }
      
          if (activeService === "Qualified Models") {
            return (
              <motion.div 
                initial={{ y: 20, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                className="space-y-8"
              >
                <div className="grid md:grid-cols-2 gap-12">
                  <div>
                    <h2 className="text-3xl font-bold mb-6 bg-clip-text text-transparent bg-gradient-to-r from-emerald-400 to-emerald-600">
                      Qualified Models
                    </h2>
                    <p className="text-gray-300 mb-6">
                      Explore our comprehensive list of qualified models that are compatible with aiDAPTIV+. 
                      From language models to image classification, find the perfect model for your needs.
                    </p>
                    <button
                      onClick={() => setShowModelsDialog(true)}
                      className="px-8 py-3 bg-gradient-to-r from-emerald-500 to-emerald-600 rounded-full font-semibold hover:opacity-90 transition-opacity"
                    >
                      View All Models
                    </button>
                  </div>
                  <div className="grid grid-cols-2 gap-4">
                    {models.slice(0, 4).map((model) => (
                      <div
                        key={model.id}
                        className="p-4 rounded-lg bg-gray-800/50 backdrop-blur-xl border border-white/10"
                      >
                        <h3 className="font-medium text-white mb-2">{model.name}</h3>
                        <p className="text-sm text-gray-400">{model.type}</p>
                      </div>
                    ))}
                  </div>
                </div>
              </motion.div>
            );
          }
      
          if (activeService === "Qualified GPUs") {
            return (
              <motion.div 
                initial={{ y: 20, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                className="space-y-8"
              >
                <div className="grid md:grid-cols-2 gap-12">
                  <div>
                    <h2 className="text-3xl font-bold mb-6 bg-clip-text text-transparent bg-gradient-to-r from-emerald-400 to-emerald-600">
                      Qualified GPUs
                    </h2>
                    <p className="text-gray-300 mb-6">
                      Discover our selection of qualified GPUs that work seamlessly with aiDAPTIV+. 
                      From consumer cards to data center solutions, find the right GPU for your workload.
                    </p>
                    <button
                      onClick={() => setShowGPUsDialog(true)}
                      className="px-8 py-3 bg-gradient-to-r from-emerald-500 to-emerald-600 rounded-full font-semibold hover:opacity-90 transition-opacity"
                    >
                      View All GPUs
                    </button>
                  </div>
                  <div className="grid grid-cols-2 gap-4">
                    {gpus.slice(0, 4).map((gpu) => (
                      <div
                        key={gpu.id}
                        className="p-4 rounded-lg bg-gray-800/50 backdrop-blur-xl border border-white/10"
                      >
                        <h3 className="font-medium text-white mb-2">{gpu.name}</h3>
                        <p className="text-sm text-gray-400">{gpu.memory}</p>
                      </div>
                    ))}
                  </div>
                </div>
              </motion.div>
            );
          }


    if (activeService === "aiDAPTIV+") {
      return (
        <div className="w-full">
          <FeaturesSection/>
          <div className="grid md:grid-cols-2 gap-12 py-8">
            <motion.div 
              initial={{ x: -50, opacity: 0 }}
              whileInView={{ x: 0, opacity: 1 }}
              transition={{ duration: 0.5 }}
              viewport={{ once: true }}
              className="backdrop-blur-xl bg-white/5 rounded-xl p-6 border border-white/10"
            >
              <div className="h-[400px] w-full">
                <ResponsiveContainer width="100%" height="100%">
                  <BarChart data={trainingData}>
                    <XAxis dataKey="name" stroke="#9CA3AF" />
                    <YAxis stroke="#9CA3AF" label={{ value: 'GPU Count', angle: -90, position: 'insideLeft' }} />
                    <Bar dataKey="aiDaptiv" fill="#10B981" name="aiDAPTIV+" />
                    <Bar dataKey="gpuOnly" fill="#6B7280" name="GPU Only" />
                  </BarChart>
                </ResponsiveContainer>
              </div>
              <div className="flex gap-4 justify-center mt-4">
                <div className="flex items-center gap-2">
                  <div className="w-3 h-3 bg-emerald-500 rounded-full"></div>
                  <span className="text-gray-300">aiDAPTIV+</span>
                </div>
                <div className="flex items-center gap-2">
                  <div className="w-3 h-3 bg-gray-500 rounded-full"></div>
                  <span className="text-gray-300">GPU Only</span>
                </div>
              </div>
            </motion.div>

            <motion.div 
              initial={{ x: 50, opacity: 0 }}
              whileInView={{ x: 0, opacity: 1 }}
              transition={{ duration: 0.5 }}
              viewport={{ once: true }}
              className="space-y-6"
            >
              {modelInfo.map((model, index) => (
                <motion.div
                  key={model.title}
                  initial={{ y: 20, opacity: 0 }}
                  whileInView={{ y: 0, opacity: 1 }}
                  transition={{ delay: index * 0.1 }}
                  viewport={{ once: true }}
                  className="backdrop-blur-xl bg-white/5 rounded-xl p-6 border border-white/10 hover:bg-white/10 transition-all duration-300"
                >
                  <div className="flex justify-between items-center mb-4">
                    <h3 className="text-xl font-semibold text-white">{model.title}</h3>
                    <Info className="text-gray-400 w-5 h-5" />
                  </div>
                  <div className="grid grid-cols-2 gap-4">
                    <div>
                      <p className="text-gray-400 text-sm">Training Set</p>
                      <p className="text-white">{model.trainingSet}</p>
                    </div>
                    <div>
                      <p className="text-gray-400 text-sm">HBM Usage</p>
                      <p className="text-white">{model.hbmUsage}</p>
                    </div>
                    <div>
                      <p className="text-gray-400 text-sm">GPU Count</p>
                      <p className="text-white">{model.gpuCount}</p>
                    </div>
                  </div>
                </motion.div>
              ))}
            </motion.div>
          </div>

          <motion.div 
            initial={{ y: 20, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.3 }}
            viewport={{ once: true }}
            className="mt-12"
          >
            <div className="backdrop-blur-xl bg-white/5 rounded-xl p-6 border border-white/10">
              <h4 className="text-lg font-semibold text-white mb-4">System Configuration:</h4>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                <div>
                  <p className="text-gray-400 text-sm">RAM</p>
                  <p className="text-white">512 GB</p>
                </div>
                <div>
                  <p className="text-gray-400 text-sm">GPU</p>
                  <p className="text-white">4x RTX 6000 ada</p>
                </div>
                <div>
                  <p className="text-gray-400 text-sm">HBM</p>
                  <p className="text-white">192 GB</p>
                </div>
              </div>
            </div>
          </motion.div>
         
          {/* <motion.div className="mt-8 flex justify-center">
            <a href="/Hyper_x_aiDAPTIV+.pdf" target='_blank'>
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className="px-8 py-3 bg-emerald-500 rounded-full font-semibold hover:bg-emerald-600 transition-colors"
              >
                DOWNLOAD BROCHURE
              </motion.button>
            </a>
          </motion.div> */}

          
        </div>
      )
    }
    

    // Default layout for other services
    return (
        <motion.div 
          key={activeService}
          initial={{ y: 50, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.5 }}
          className="grid md:grid-cols-2 gap-12 items-center"
        >
          <motion.div
            initial={{ x: -50, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ delay: 0.2 }}
          >
            <h2 className="text-3xl md:text-4xl font-bold mb-6 bg-clip-text text-transparent bg-gradient-to-r from-blue-400 to-emerald-600">
              {servicesData[activeService].title}
            </h2>
            <p className="text-gray-300 mb-6">
              {servicesData[activeService].description}
            </p>
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="px-8 py-3 bg-gradient-to-r from-blue-500 to-emerald-600 rounded-full font-semibold hover:opacity-90 transition-opacity"
            >
              Learn More
            </motion.button>
          </motion.div>
          <motion.div 
            initial={{ x: 50, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ delay: 0.4 }}
            className="relative h-[400px] rounded-xl overflow-hidden group"
          >
            <div className="absolute inset-0 backdrop-blur-xl bg-white/5 border border-white/10 transition-all duration-300 group-hover:bg-white/10">
              <div 
                className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"
                style={{
                  backgroundImage: `url(${servicesData[activeService].imagePath})`,
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                }}
              />
            </div>
          </motion.div>
        </motion.div>
      );
    };
  
    return (
      <div className="min-h-screen bg-black text-white">
        {/* Hero Section */}
        <motion.section
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1 }}
          className="relative h-screen lg:h-screen 2xl:h-[60vh] flex items-center justify-center"
        >
          <div
            className="absolute inset-0 z-0 bg-gradient-to-b from-black/40 to-black"
            style={{
              backgroundImage: `url(${aidaptiv_background})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              filter: 'brightness(0.3)'
            }}
          />
          <div className="relative z-10 max-w-4xl mx-auto px-4 text-center">
            <motion.h1
              initial={{ y: 20, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ delay: 0.5 }}
              className="text-5xl md:text-7xl font-bold mb-6 py-4 leading-tight bg-clip-text text-transparent bg-gradient-to-r from-blue-400 to-emerald-600"
            >
              Expanding Horizons
            </motion.h1>
            <motion.p
              initial={{ y: 20, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ delay: 0.5 }}
              className="text-lg md:text-xl text-gray-300"
            >
              We innovate and push boundaries, focusing on growth while maintaining fiscal responsibility
            </motion.p>
          </div>
        </motion.section>
        {/* Services Overview */}
        <section className="py-20 px-4">
          <div className="max-w-6xl mx-auto">
            {/* Service Navigation */}
            <motion.div 
              initial={{ y: 50, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              transition={{ duration: 0.5 }}
              viewport={{ once: true }}
              className="flex flex-wrap justify-center gap-4 mb-20"
            >
              {Object.keys(servicesData).map((service) => (
                <motion.button
                  key={service}
                  onClick={() => setActiveService(service)}
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  className={`px-6 py-3 rounded-full transition-all duration-300 backdrop-blur-xl border ${
                    activeService === service
                      ? "bg-white/10 border-emerald/20 shadow-lg"
                      : "border-white/5 hover:bg-white/5"
                  }`}
                >
                  {service}
                </motion.button>
              ))}
            </motion.div>
  
            {/* Service Content */}
            {renderServiceContent()}
          </div>
        </section>
  
        {/* Dialogs */}
        <SearchDialog
          isOpen={showModelsDialog}
          onClose={() => setShowModelsDialog(false)}
          items={models}
          type="models"
        />
        <SearchDialog
          isOpen={showGPUsDialog}
          onClose={() => setShowGPUsDialog(false)}
          items={gpus}
          type="gpus"
        />
      </div>
    );
  }